import{ SelectContainer, StyledSelect, StyledOption} from './styles';

const Select = ({ options, value, onChange}) => {
  return (
      <SelectContainer>
          <StyledSelect value={value} onChange={onChange}>
              {options ? options.map((option) => (
                  <StyledOption key={option.value} value={option.value}>
                      {option.label}
                  </StyledOption>
              )) : <></>}
          </StyledSelect>
      </SelectContainer>
  );
};

export default Select;
